/* ============================================================================
 * sup-2026.js — GSAP choreography for the support-page band family.
 * One file serves every .sup2 section:
 *   [data-sup2]        section root (bound once)
 *   [data-sup2-head]   header -> canonical masked SplitText title reveal,
 *                      siblings stagger in after (0.2s past `top 78%`, once,
 *                      gated on document.fonts.ready — flash-proof set+to)
 *   [data-sup2-title]  the h2 inside the header
 *   [data-sup2-item]   cards / rows -> batched fade-up on scroll-in
 *   [data-sup2-spot]   spotlight tracking (--mx/--my custom props)
 * Nothing is CSS-hidden up front: if GSAP never arrives, content just shows.
 * ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  function initSpotlight(root) {
    if (!fine) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-sup2-spot]'), function (el) {
      if (el.dataset.sup2SpotBound) return;
      el.dataset.sup2SpotBound = '1';
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        el.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
    });
  }

  function buildSection(root) {
    try {
      var head = root.querySelector('[data-sup2-head]');
      if (head && !head.dataset.sup2Built) {
        head.dataset.sup2Built = '1';
        var title = head.querySelector('[data-sup2-title]');
        var others = Array.prototype.slice.call(head.children).filter(function (el) { return el !== title; });
        var lines = null;
        if (title && window.SplitText) {
          gsap.registerPlugin(SplitText);
          try { lines = SplitText.create(title, { type: 'lines', mask: 'lines' }).lines; } catch (err) { lines = null; }
        }
        var tl = gsap.timeline({ paused: true });
        if (lines) { gsap.set(lines, { yPercent: 110 }); tl.to(lines, { yPercent: 0, duration: 0.9, ease: 'expo.out', stagger: 0.12 }, 0.1); }
        else if (title) { gsap.set(title, { y: 26, autoAlpha: 0 }); tl.to(title, { y: 0, autoAlpha: 1, duration: 0.8, ease: 'power3.out' }, 0.1); }
        if (others.length) { gsap.set(others, { y: 18, autoAlpha: 0 }); tl.to(others, { y: 0, autoAlpha: 1, duration: 0.6, ease: 'power3.out', stagger: 0.1 }, 0.3); }
        ScrollTrigger.create({ trigger: head, start: 'top 78%', once: true, onEnter: function () { gsap.delayedCall(0.2, function () { tl.play(); }); } });
      }

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-sup2-item]')).filter(function (el) { return !el.dataset.sup2Built; });
      if (items.length) {
        items.forEach(function (el) { el.dataset.sup2Built = '1'; });
        gsap.set(items, { autoAlpha: 0, y: 28 });
        ScrollTrigger.batch(items, {
          start: 'top 88%', once: true, interval: 0.06, batchMax: 8,
          onEnter: function (batch) { gsap.to(batch, { autoAlpha: 1, y: 0, duration: 0.6, ease: 'power3.out', stagger: 0.07, overwrite: true, clearProps: 'transform,opacity,visibility' }); }
        });
      }
    } catch (err) {
      if (window.console) console.warn('sup2:', err);
    }
  }

  ready(function () {
    var roots = document.querySelectorAll('[data-sup2]');
    if (!roots.length) return;
    Array.prototype.forEach.call(roots, initSpotlight);
    if (reduce) return;

    (function go(n) {
      if (!window.gsap || !window.ScrollTrigger) { if (n > 60) return; return setTimeout(function () { go(n + 1); }, 60); }
      gsap.registerPlugin(ScrollTrigger);
      function buildAll() {
        Array.prototype.forEach.call(document.querySelectorAll('[data-sup2]'), buildSection);
        ScrollTrigger.refresh();
      }
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(buildAll); } else { buildAll(); }
    })(0);

    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target || !e.target.querySelector) return;
      var root = e.target.querySelector('[data-sup2]');
      if (root && window.gsap && window.ScrollTrigger) { initSpotlight(root); buildSection(root); }
    });
  });
})();
